"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = ["M13.5 6a2.5 2.5 0 00-2.45 2h-1.3L5.74 4l-.75.75L8.25 8h-3.3a2.5 2.5 0 100 1h3.3l-3.26 3.25.75.75 4.01-4h1.3a2.5 2.5 0 102.45-3z"];
//# sourceMappingURL=flows.js.map